import { put, takeEvery } from 'redux-saga/effects';
import { ActionTypes } from 'src/store/requests/app/actions';
import { IAppRequest } from 'src/typings/app';
import { Actions } from 'src/store/locale/actions';
import { FormatedPrice } from 'src/helpers/getFormatedPrice';

export function* setLocaleData(action: {
  type: string,
  payload: IAppRequest,
}) {
  const formatedPrice = FormatedPrice.formatNumberWithLocaleSeparator(action.payload?.form?.form_default_country?.toUpperCase() || 'UA');
  yield put(Actions.setLocale(formatedPrice));
}
export function* getLocaleWatchSaga() {
  yield takeEvery(ActionTypes.GET_APP_DATA_REQUEST_SUCCESS, setLocaleData);
}
